// ToolSavedStylesContainerEditSavedStyleDiv.jsx
import React from 'react';
import ReactQuill from 'react-quill';
import { Button } from 'react-bootstrap';
import { Quill } from 'react-quill';

// Import Parchment to use for custom attributors
const Parchment = Quill.import('parchment');

// Define size whitelist using pixel equivalents of point sizes
const Size = Quill.import('formats/size');
Size.whitelist = [
  '8px', '9px', '10px', '11px', '12px', '14px', '15px',
  '16px', // default value
  '18px', '20px', '24px', '28px', '32px', '36px', '48px', '64px', '72px', '96px', '100px'
];
Quill.register(Size, true);

// ✅ Define and register custom line-height attributor
const LineHeightStyle = new Parchment.Attributor.Style('line-height', 'line-height', {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['1', '1.5', '2', '2.5', '3'],
});
Quill.register(LineHeightStyle, true);

const ToolSavedStylesContainerEditSavedStyleDiv = ({
  index,
  style,
  setSavedStyles,
  clearTextFormattingInSavedStyle,
  saveCurrentStyleNamesStylingToSavedStyle,
  clickButtonEditStyleToolDiscard,
  clickButtonEditStyleToolSave123,
}) => {
  return (
    <div
      id={`editSavedStyleDiv-${index}`}
      style={{
        display: 'none',
        marginTop: '8px',
        padding: '8px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #ccc',
        borderRadius: '6px',
      }}
    >
      <div style={{ fontWeight: 'bold', marginBottom: '6px' }}>Edit Saved Style</div>

      <div id={`quill-toolbar-${index}`} style={{ marginBottom: '10px' }}>
        <ReactQuill
          value={style.value || (style.name || `Saved Style ${index + 1}`)}
          onChange={(value, delta, source, editor) => {
            const plainText = editor.getText().trim();
            setSavedStyles((prevStyles) => {
              const updatedStyles = [...prevStyles];
              const existing = updatedStyles[index] || {};
              updatedStyles[index] = {
                ...existing,
                value,
                name: plainText || existing.name || `Saved Style  ${index + 1}`,
              };
              return updatedStyles;
            });
          }}
          modules={{
            toolbar: [
              [{ font: [] }],
              [{ size: Size.whitelist }],
              [{ 'line-height': ['1', '1.5', '2', '2.5', '3'] }], // <-- Corrected line-height configuration
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ align: [] }],
              ['bold', 'italic', 'underline', 'strike'],
              ['link'],
              [{ color: [] }, { background: [] }],
              ['blockquote', 'code-block'],
            ],
          }}
          formats={[
            'font', 'size', 'line-height', 'list', 'bullet', 'indent', 'align',
            'bold', 'italic', 'underline', 'strike', 'link',
            'color', 'background', 'blockquote', 'code-block'
          ]}
          id={`quill-editor-${index}`}
          style={{ width: '100%' }}
        />
      </div>

      <div>
        <Button
          id={`buttonSelectAllText-${index}`}
          variant="outline-primary"
          size="sm"
          className="m-1"
          style={{
            padding: '2px 6px',
            fontSize: '0.65rem',
            fontWeight: 'bold',
            display: 'none',
          }}
          onClick={() => {
            const quillEditor = document.querySelector(`#quill-editor-${index} .ql-editor`);
            if (!quillEditor) return console.warn(`Quill editor not found for index ${index}`);
            const quill = quillEditor.closest('.ql-container')?.__quill;
            if (!quill) return console.warn(`Quill instance not found for index ${index}`);
            quill.setSelection(0, quill.getLength());
            console.log(`Selected all text in editor for index ${index}`);
          }}
        >
          SELECT ALL Text
        </Button>

        <Button
          id={`button1ClearFormatToSavedStyle-${index}`}
          size="sm"
          variant="secondary"
          className="m-1"
          onClick={() => clearTextFormattingInSavedStyle(index)}
          style={{ display: 'none' }}
        >
          1 CLEAR Format to Saved Style
        </Button>

        <Button
          id={`button2SaveCurrentStyleNamesStylingToSavedStyle-${index}`}
          size="sm"
          variant="secondary"
          className="m-1"
          onClick={() => saveCurrentStyleNamesStylingToSavedStyle(index)}
          style={{ display: 'none' }}
        >
          2 SAVE Current Style Name's Styling to Saved Style
        </Button>

        <Button
          id={`buttonEditStyleToolDiscard-${index}`}
          size="sm"
          variant="warning"
          className="m-1"
          onClick={() => clickButtonEditStyleToolDiscard(index)}
        >
          Discard Edit
        </Button>

        <Button
          id={`buttonEditStyleToolClose-${index}`}
          size="sm"
          variant="secondary"
          className="m-1"
          onClick={(e) => {
            const discardButton = document.getElementById(`buttonEditStyleToolDiscard-${index}`);
            if (discardButton) discardButton.click();
            const parentDiv = e.target.closest('div[id^="editSavedStyleDiv-"]');
            if (parentDiv) parentDiv.style.display = 'none';
          }}
        >
          Discard Edit and Close
        </Button>

        <Button
          id={`button3EditStyleToolSave-${index}`}
          size="sm"
          variant="secondary"
          className="m-1"
          onClick={() => {
            const quill = document.querySelector(`#quill-editor-${index} .ql-editor`);
            const plainText = quill?.innerText?.trim();
            if (plainText !== undefined) {
              setSavedStyles((prevStyles) => {
                const updatedStyles = [...prevStyles];
                updatedStyles[index] = {
                  ...updatedStyles[index],
                  name: plainText || `Saved Style  ${index + 1}`,
                };
                return updatedStyles;
              });
            }
            const editDiv = document.getElementById(`editSavedStyleDiv-${index}`);
            if (editDiv) editDiv.style.display = 'none';
          }}
          style={{ display: 'none' }}
        >
          3 Save Edit
        </Button>

        <Button
          id={`buttonEditStyleToolSave1-2-3-${index}`}
          size="sm"
          variant="success"
          className="m-1"
          onClick={() => clickButtonEditStyleToolSave123(index)}
        >
          Save Edit and Close
        </Button>
      </div>
    </div>
  );
};

export default ToolSavedStylesContainerEditSavedStyleDiv;
